import { getFlattenedFileNameOverrides } from "../../store/selectors/input/attachments/attachmentsSelectors";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { commands } from "@uiw/react-md-editor/nohighlight";
import Markdown from "components/common/Markdown";
import * as commandUtils from "components/common/notes/commandUtils";
import NotesFileSelector from "components/common/notes/commands/Attachment";
import { insertAttachment } from "components/common/notes/commands/Attachment";
import { insertPhoto } from "components/common/notes/commands/Image";
import { link } from "components/common/notes/commands/Link";
import { insert2x2Table as insertTable } from "components/common/notes/commands/Table";
import React from "react";
import { connect } from "react-redux";
import * as attachmentActions from "store/actions/input/attachments/attachmentsActions";
import * as actions from "store/actions/input/images/imagesActions";
import { isSelectingAttachments } from "store/selectors/temp/attachments/tempAttachmentsSelectors";

const FeedbackInput = ({
  value,
  onChange,
  placeholder,
  uploadImage,
  openAttachmentSelectionDialog,
  closeAttachmentSelectionDialog,
  isSelectingAttachment,
  allowAttachments = true,
  allowImages = true,
  attachmentNames,
}) => {
  const toolbarCommands = [
    commandUtils.withTrimmedSelection(commands.bold),
    commandUtils.withTrimmedSelection(commands.italic),
    commandUtils.withTrimmedSelection(commands.strikethrough),
    commands.title,
    commands.divider,
    link,
    commands.quote,
    commands.divider,
    commands.unorderedListCommand,
    commands.orderedListCommand,
    commands.checkedListCommand,
    commands.divider,
    insertTable,
    commands.divider,
    ...(allowAttachments
      ? [insertAttachment(openAttachmentSelectionDialog)]
      : []),
    ...(allowImages ? [insertPhoto(uploadImage)] : []),
  ];

  const attachmentSelected = (meta) => {
    let viewName = meta.originalFilename;
    const params = {
      fileId: meta.id,
      mime: meta.mimeType,
    };
    const override = attachmentNames[meta.id];
    if (override) {
      params["filename"] = override;
      viewName = override;
    }

    const url = "/attachments/fileView?" + new URLSearchParams(params);
    onChange(value + "\n[" + viewName + "](" + url + ")\n");
    closeAttachmentSelectionDialog();
  };

  if (isSelectingAttachment) {
    return (
      <Stack direction={"column"}>
        <NotesFileSelector onSelected={attachmentSelected} fullWidth />
        <Stack direction={"row"} justifyContent={"flex-end"}>
          <Button
            disableElevation
            variant={"contained"}
            key={"disabled"}
            sx={{ width: "80px", height: "36px", marginTop: "12px" }}
            onClick={closeAttachmentSelectionDialog}
          >
            {"Cancel"}
          </Button>
        </Stack>
      </Stack>
    );
  }

  return (
    <Markdown
      value={value}
      onChange={onChange}
      commands={toolbarCommands}
      placeholder={placeholder}
      editMode
    />
  );
};

const mapDispatchToProps = {
  uploadImage: actions.uploadImage,
  openAttachmentSelectionDialog:
    attachmentActions.openAttachmentSelectionDialog,
  closeAttachmentSelectionDialog:
    attachmentActions.closeAttachmentSelectionDialog,
};

const mapStateToProps = (state) => ({
  isSelectingAttachment: isSelectingAttachments(state),
  attachmentNames: getFlattenedFileNameOverrides(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackInput);
